import { useMutation, useQueryClient } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function UseUpdateLeaveType(cb) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.LEAVETYPES_API,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        cb();
        queryClient.invalidateQueries('get-leave-types');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
